
















import { Component, Prop, Ref } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import HeadBannerNav from '@/components/homescapes/hs000v1/HeadBannerNav.vue';
import HeadBannerLogo from '@/components/homescapes/hs000v1/HeadBannerLogo.vue';
import PlayButton from '@/components/PlayButton.vue';
import LoginButton from '@/components/LoginButton.vue';
import XsollaModal from '@/components/xsolla/XsollaModal.vue';

import AuthMixin from '@/mixins/auth';

import { addGtmEvent, GTMEvent } from '@/helpers/gtm';

@Component({
  components: {
    HeadBannerNav,
    HeadBannerLogo,
    PlayButton,
    LoginButton,
    XsollaModal,
  },
})
export default class HeadBanner extends mixins(AuthMixin) {
  @Prop(String) readonly variant!: string;

  @Ref() readonly auth!: XsollaModal;

  get classes() {
    const { root, 'variant-0': defaultVariant } = this.$style;

    const variant = this.$style[`variant-${this.variant}`];

    return [root, variant || defaultVariant];
  }

  handlePlayClick() {
    addGtmEvent(GTMEvent.LANDING_CLICK);
  }

  handleLoginClick() {
    this.auth.show();
  }
}
